/**
 * Rozhraní umožňující zobrazit informaci o čekání na probíhající akci (loader)
 */
export interface ILoader {
    /**
     * Zobrazí loader
     */
    showLoader(): void;
    /**
     * Skryje loader
     */
    hideLoader(): void;
    /**
     * Poskytuje informaci o tom, zda je právě zobrazený loader
     */
    isLoading(): boolean;
}

export class ILoader {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            Reflect.has(instance, "showLoader") &&
            Reflect.has(instance, "hideLoader") &&
            Reflect.has(instance, "isLoading");
    }
}
